/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Explore_Collections_DetailInputs */

const en_common_header_explore_collections_detail = /** @type {(inputs: Common_Header_Explore_Collections_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curated product lists`)
};

const zh_common_header_explore_collections_detail = /** @type {(inputs: Common_Header_Explore_Collections_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选产品清单`)
};

/**
* | output |
* | --- |
* | "Curated product lists" |
*
* @param {Common_Header_Explore_Collections_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore_collections_detail = /** @type {((inputs?: Common_Header_Explore_Collections_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Explore_Collections_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore_collections_detail(inputs)
	return zh_common_header_explore_collections_detail(inputs)
});
export { common_header_explore_collections_detail as "common.header.explore.collections.detail" }